"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CompanyType = exports.InsuranceType = exports.ReceivableLoanRedemptionType = exports.InsuranceRedemptionType = exports.LoanpartTypeStatus = exports.ExpenseTypes = exports.PortfolioRisk = exports.RiskProfile = exports.IncomeTypes = void 0;
var IncomeTypes = /*#__PURE__*/function (IncomeTypes) {
  IncomeTypes["Alimony"] = "Alimony";
  IncomeTypes["Allowance"] = "Allowance";
  IncomeTypes["Annuity"] = "Annuity";
  IncomeTypes["ChildAllowance"] = "ChildAllowance";
  IncomeTypes["DGA"] = "DGA";
  IncomeTypes["ElderlyPension"] = "ElderlyPension";
  IncomeTypes["Employed"] = "Employed";
  IncomeTypes["Endowment"] = "Endowment";
  IncomeTypes["Flexworker"] = "Flexworker";
  IncomeTypes["FlexworkerWithoutPerspective"] = "FlexworkerWithoutPerspective";
  IncomeTypes["Foreign"] = "Foreign";
  IncomeTypes["Freelancer"] = "Freelancer";
  IncomeTypes["Gift"] = "Gift";
  IncomeTypes["Inheritance"] = "Inheritance";
  IncomeTypes["LumpSumAnnuity"] = "LumpSumAnnuity";
  IncomeTypes["OtherActivities"] = "OtherActivities";
  IncomeTypes["OtherNonTaxableIncome"] = "OtherNonTaxableIncome";
  IncomeTypes["OtherTaxableIncome"] = "OtherTaxableIncome";
  IncomeTypes["PartnerAlimony"] = "PartnerAlimony";
  IncomeTypes["PartnerPension"] = "PartnerPension";
  IncomeTypes["Pension"] = "Pension";
  IncomeTypes["Permanent"] = "Permanent";
  IncomeTypes["RentalIncome"] = "RentalIncome";
  IncomeTypes["SeasonalWorker"] = "SeasonalWorker";
  IncomeTypes["SeverancePay"] = "SeverancePay";
  IncomeTypes["StatePension"] = "StatePension";
  IncomeTypes["SubstantialInterest"] = "SubstantialInterest";
  IncomeTypes["TemporaryWithPositiveIntent"] = "TemporaryWithPositiveIntent";
  IncomeTypes["TemporaryWithoutPositiveIntent"] = "TemporaryWithoutPositiveIntent";
  IncomeTypes["Unemployed"] = "Unemployed";
  IncomeTypes["UnemploymentBenefit"] = "UnemploymentBenefit";
  IncomeTypes["WajongBenefit"] = "WajongBenefit";
  IncomeTypes["WaoBenefit"] = "WaoBenefit";
  return IncomeTypes;
}(IncomeTypes || (exports.IncomeTypes = IncomeTypes = {}));
var RiskProfile = /*#__PURE__*/function (RiskProfile) {
  RiskProfile["Saving"] = "Saving";
  RiskProfile["VeryDefensive"] = "VeryDefensive";
  RiskProfile["Defensive"] = "Defensive";
  RiskProfile["Neutral"] = "Neutral";
  RiskProfile["Offensive"] = "Offensive";
  RiskProfile["VeryOffensive"] = "VeryOffensive";
  return RiskProfile;
}(RiskProfile || (exports.RiskProfile = RiskProfile = {}));
var PortfolioRisk = /*#__PURE__*/function (PortfolioRisk) {
  PortfolioRisk["VeryDefensive"] = "VeryDefensive";
  PortfolioRisk["Defensive"] = "Defensive";
  PortfolioRisk["Neutral"] = "Neutral";
  PortfolioRisk["ModeratelyOffensive"] = "ModeratelyOffensive";
  PortfolioRisk["Offensive"] = "Offensive";
  PortfolioRisk["VeryOffensive"] = "VeryOffensive";
  return PortfolioRisk;
}(PortfolioRisk || (exports.PortfolioRisk = PortfolioRisk = {}));
var ExpenseTypes = /*#__PURE__*/function (ExpenseTypes) {
  ExpenseTypes["Unknown"] = "Unknown";
  ExpenseTypes["PaidAlimony"] = "PaidAlimony";
  ExpenseTypes["HouseholdExpense"] = "HouseholdExpense";
  ExpenseTypes["OverigeVasteLasten"] = "OverigeVasteLasten";
  ExpenseTypes["Vervoer"] = "Vervoer";
  ExpenseTypes["SportEnHobbies"] = "SportEnHobbies";
  ExpenseTypes["BoodschappenHuishoudgeld"] = "BoodschappenHuishoudgeld";
  ExpenseTypes["OnregelmatigeUitgaven"] = "OnregelmatigeUitgaven";
  ExpenseTypes["Vakantievrijetijd"] = "Vakantievrijetijd";
  ExpenseTypes["Woning"] = "Woning";
  ExpenseTypes["Rent"] = "Rent";
  ExpenseTypes["UtilityCosts"] = "UtilityCosts";
  ExpenseTypes["Insurances"] = "Insurances";
  ExpenseTypes["Subscriptions"] = "Subscriptions";
  ExpenseTypes["Education"] = "Education";
  ExpenseTypes["Clothing"] = "Clothing";
  ExpenseTypes["InventoryHome"] = "InventoryHome";
  ExpenseTypes["HealthExpenses"] = "HealthExpenses";
  ExpenseTypes["Taxes"] = "Taxes";
  ExpenseTypes["ChildExpense"] = "ChildExpense";
  ExpenseTypes["TeenExpense"] = "TeenExpense";
  ExpenseTypes["PrivateLease"] = "PrivateLease";
  ExpenseTypes["TelecomCredit"] = "TelecomCredit";
  ExpenseTypes["VVE"] = "VVE";
  ExpenseTypes["BankingServiceCosts"] = "BankingServiceCosts";
  ExpenseTypes["LoanCosts"] = "LoanCosts";
  ExpenseTypes["Miscellaneous"] = "Miscellaneous";
  ExpenseTypes["Total"] = "Total";
  ExpenseTypes["MortgageCosts"] = "MortgageCosts";
  ExpenseTypes["EstimatedMortgageCosts"] = "EstimatedMortgageCosts";
  ExpenseTypes["BuyPropertyMortgageCosts"] = "BuyPropertyMortgageCosts";
  ExpenseTypes["OtherExpenditure"] = "OtherExpenditure";
  ExpenseTypes["UncategorizedEstimate"] = "UncategorizedEstimate";
  return ExpenseTypes;
}(ExpenseTypes || (exports.ExpenseTypes = ExpenseTypes = {}));
var LoanpartTypeStatus = /*#__PURE__*/function (LoanpartTypeStatus) {
  LoanpartTypeStatus["New"] = "New";
  LoanpartTypeStatus["Existing"] = "Existing";
  LoanpartTypeStatus["Bridge"] = "Bridge ";
  return LoanpartTypeStatus;
}(LoanpartTypeStatus || (exports.LoanpartTypeStatus = LoanpartTypeStatus = {}));
var InsuranceRedemptionType = /*#__PURE__*/function (InsuranceRedemptionType) {
  InsuranceRedemptionType["Fixed"] = "Fixed";
  InsuranceRedemptionType["DecreasingAnnuity"] = "DecreasingAnnuity";
  InsuranceRedemptionType["DecreasingLinear"] = "DecreasingLinear";
  return InsuranceRedemptionType;
}(InsuranceRedemptionType || (exports.InsuranceRedemptionType = InsuranceRedemptionType = {}));
var ReceivableLoanRedemptionType = /*#__PURE__*/function (ReceivableLoanRedemptionType) {
  ReceivableLoanRedemptionType["ANNUITY_LOAN"] = "AnnuityLoan";
  ReceivableLoanRedemptionType["LINEAR_LOAN"] = "LinearLoan";
  ReceivableLoanRedemptionType["INTEREST_ONLY_LOAN"] = "InterestOnlyLoan";
  return ReceivableLoanRedemptionType;
}(ReceivableLoanRedemptionType || (exports.ReceivableLoanRedemptionType = ReceivableLoanRedemptionType = {}));
var InsuranceType = /*#__PURE__*/function (InsuranceType) {
  InsuranceType["AnnuitySavingsPlanPolicy"] = "AnnuitySavingsPlanPolicy";
  InsuranceType["SavingsPlanPolicy"] = "SavingsPlanPolicy";
  InsuranceType["DisabilityInsurancePolicy"] = "DisabilityInsurancePolicy";
  InsuranceType["MortgagePaymentProtectionInsurancePolicy"] = "MortgagePaymentProtectionInsurancePolicy";
  InsuranceType["TermLifeInsurancePolicy"] = "TermLifeInsurancePolicy";
  InsuranceType["IncapacitatedWithUnemploymentBenefit"] = "IncapacitatedWithUnemploymentBenefit";
  InsuranceType["IncapacitatedWithoutUnemploymentBenefit"] = "IncapacitatedWithoutUnemploymentBenefit";
  InsuranceType["EndowmentInsurancePolicy"] = "EndowmentInsurancePolicy";
  return InsuranceType;
}(InsuranceType || (exports.InsuranceType = InsuranceType = {}));
var CompanyType = /*#__PURE__*/function (CompanyType) {
  CompanyType["Unknown"] = "Unknown";
  CompanyType["SoleProprietorship"] = "SoleProprietorship";
  CompanyType["VOF"] = "VOF";
  CompanyType["MutualGuaranteeCompany"] = "MutualGuaranteeCompany";
  CompanyType["Partnership"] = "Partnership";
  CompanyType["Association"] = "Association";
  CompanyType["Foundation"] = "Foundation";
  CompanyType["CV"] = "CV";
  CompanyType["NV"] = "NV";
  CompanyType["BV"] = "BV";
  return CompanyType;
}(CompanyType || (exports.CompanyType = CompanyType = {}));

